<template>
  <hr class="line" />
</template>

<script>
export default {
  name: 'BaseLine',
}
</script>

<style scoped lang="scss">
.line {
  width: 100%;
  height: 1px;
  border: none;
  background-color: #969FA8;
}
</style>
